import { http } from "helpers/Http";
import { IAddUserParams } from "types/User";

export async function postRegisterUser(user: IAddUserParams): Promise<any> {
    const url = `users/new?current_app_id=${user?.place_id}&cardapio_web=true`;
    delete user.place_id;
    const data = http.post(url, user).then((response) => response.data);
    return data;
}